<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-list [ttData]="tables" [ttButtons]="rowButtons" [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="usergrouptable_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card *ngIf="itemState === 'usergrouptableedit'" class="col-xs-12 p-5" ttHeading="h_usergroup_table"></tt-card>
                    <tt-list class="col-xs-12 p-5" [ttData]="tables" [ttButtons]="rowButtons" [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-usergroup-table-edit *ngIf="itemState === 'usergrouptableedit'" [hidden]="selectedId === ''" class="col-xs-12 p-5" [p2UserGroupTableKeyno]="selectedId" (onSave)="updateList()"></tt-usergroup-table-edit>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>
